import React from 'react';

import VerticalBookCardList from 'rebook/apps/books/components/VerticalBookCardList';

import LandingContentContainer from '../LandingContentContainer';


const NoveltyBooksBlock = ({ noveltyBookset, noveltyBooksetModel }) => (
  <div className="billetContainerNoOverflow">
    <div className="billetContainerWrapper">
      <LandingContentContainer
        link={noveltyBooksetModel && noveltyBooksetModel.getLink()}
        title="Новинки и бестселлеры"
        linkText="Все новинки" />
      <p>Популярные и начинающие авторы, крупнейшие и нишевые издательства</p>
    </div>
    <VerticalBookCardList bookList={noveltyBookset && noveltyBookset.books} />
  </div>
);

export default NoveltyBooksBlock;
